import { useQuery } from 'react-query';
import { GUEST_USER, ORDER_MICRO_SERIVCE } from '../constants';
import { useDispatch } from 'react-redux';
import { updateTrackOrder } from 'src/redux/slices/checkoutSlice';
import axiosWithInterceptor from 'src/services/axiosWithInterceptor';
import { getUser } from 'src/helper/helperMethods';

interface IQueryParams {
  userId: number;
  userType: string;
}

const getCustomerPlacedOrders = async (
  { userId, userType }: IQueryParams,
  dispatch,
) => {
  const response = await axiosWithInterceptor.get(
    `${ORDER_MICRO_SERIVCE}/orders/history/${userId}?orderType=future&page=1&is_catering=1`,
  );
  dispatch(updateTrackOrder(response?.data?.data?.data?.length ? true : false));
  return response?.data?.data;
};

export default function useGetCustomerPlacedOrders() {
  const dispatch = useDispatch();
  const user = getUser();

  return useQuery(
    ['placedOrders', user?.id],
    () => getCustomerPlacedOrders({ userId : user?.id , userType : user?.type }, dispatch),

    {
      enabled: user?.hasOwnProperty('id') && user?.hasOwnProperty('type') && user?.type !== GUEST_USER,
      cacheTime: 0,
      initialData: undefined,
      staleTime: 0,
    },
  );
}
// orders/history/313?page=1&is_catering=1

// https://order-business-service.qa.zupas.net/api/v1/orders/351?details=payment,store,pickup,tracking,am_here
